@switch (status()) {
  @case (statusEnum.CREATED) {
    <div class="absence-status status-created-color" i18n>Creado</div>
  }
  @case (statusEnum.INACTIVE) {
    <div class="absence-status status-inactive-color" i18n>Inactivo</div>
  }
  @case (statusEnum.ACTIVE) {
    <div class="absence-status status-active-color" i18n>Activo</div>
  }
  @default {}
}
